import type * as Exp from "@ebay/experience-types-ebay";
import type { MapAccessibilityTexts, MarkerContentKey } from "../components/map/types";

export function itemCardLabel(placeholderLabel: Exp.TextualDisplay, itemIndex: number, itemsTotal: number): Exp.TextualDisplay {
  const textSpan = (placeholderLabel.textSpans || [])[0] || {};
  const text = (textSpan.text ?? "").replace(/%d/, (itemIndex + 1).toString()).replace(/%d/, itemsTotal.toString());

  return {
    textSpans: [{ text }],
  };
}
export function getMarkerAccessibilityLabel({
  mapAccessibilityTexts,
  contentKey,
  itemsTotal,
  itemTitle,
  itemPrice,
}: {
  mapAccessibilityTexts?: MapAccessibilityTexts;
  contentKey: MarkerContentKey | undefined;
  itemsTotal?: number;
  itemTitle?: string;
  itemPrice?: string;
}): string {
  if (!mapAccessibilityTexts || !contentKey) return "";

  const baseText = mapAccessibilityTexts[contentKey];
  if (!baseText) return "";

  switch (contentKey) {
    case "multipleListingMarker":
    case "doubleListingMarker":
      if (!itemTitle || !itemPrice || !itemsTotal) return "";
      return baseText.replace(/%s/, itemTitle).replace(/%s/, itemPrice).replace(/%d/, itemsTotal.toString());

    case "singleListingMarker":
      if (!itemTitle || !itemPrice) return "";
      return baseText.replace(/%s/, itemTitle).replace(/%s/, itemPrice);

    case "clusterListings":
      if (!itemsTotal) return "";
      return baseText.replace(/%d/, itemsTotal.toString());

    default:
      return "";
  }
}
